const PuntoRetiro = () => {
  return (
    <p>
      Nuestro punto de Retiro es en casa de Any! (Alberdi 1637, San Antonio de
      Padua) Vamos a coordinar con vos el encuentro.
    </p>
  );
};

export default PuntoRetiro;
